import TableView from "../Common/TableView";
import { ENTRADAS_MATERIAL_EXTENSION, generalObjectBuilder, genericDelete, genericPost, genericUpdate, paginatedGetWithProcessor } from "../../services/api.service";
import { ViewHeader } from "../Common/ViewHeader";
import { EntradasMaterialConfigs } from "./EntradasMaterial.config";


export default function EntradasMaterial() {

    return (<div className="max-h-screen">
        <TableView
            title={"Entradas Material"}
            getEntity={paginatedGetWithProcessor(ENTRADAS_MATERIAL_EXTENSION, generalObjectBuilder(EntradasMaterialConfigs))}
            postEntity={genericPost(ENTRADAS_MATERIAL_EXTENSION)}
            editEntity={genericUpdate(ENTRADAS_MATERIAL_EXTENSION)}
            deleteEntity={genericDelete(ENTRADAS_MATERIAL_EXTENSION)}
            addButtonText={"Nova entrada material"}
            searchButtonText={"Procurar Entrada material"}
            tableConfigs={EntradasMaterialConfigs}
            dataBuildFunction={generalObjectBuilder(EntradasMaterialConfigs)}
            entityName={"Entrada Material"}
            idProp={"id"}
            reroute={true}
        />
    </div>)

}

